export const crudOperations = {
  create: 'create',
  read: 'read',
  update: 'update',
  delete: 'delete',
  log: 'log'
} as const;

export type CrudOperation = typeof crudOperations[keyof typeof crudOperations];

export type CrudRoleBase<T> = T extends `${infer Prefix}_${CrudOperation}`
  ? Prefix
  : never;

export const extractCrudRole = <
  ROLE extends string,
  CRUD_ROLE extends CrudRoleBase<ROLE> = CrudRoleBase<ROLE>
>(
  role?: ROLE
): CrudRoleBase<ROLE> | undefined => {
  if (!role) {
    return undefined;
  }
  for (const key in crudOperations) {
    const operation = crudOperations[key];
    if (role.endsWith(`_${operation}`)) {
      return role.replace(`_${operation}`, '') as CRUD_ROLE;
    }
  }
};
